
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/scholarship-test",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/scholarship-test/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/scholarship-test"])
      });
    }
  